class InvalidInputError extends Error {
  constructor(err) {
    super();
    this.name = this.constructor.name;
    this.key = err.key;
    this.msg = err.msg;
    this.is_error = true;
    Error.captureStackTrace(this, this.constructor);
  }
}

export { InvalidInputError }
